import logo from './logo.svg';
import './App.css';
import 'bootstrap/dist/css/bootstrap.min.css';
import AboutUs from './pages/AboutUs';
import Members from './pages/Members';
import MembershipRegistration from './pages/MembershipRegistration';
import Activities from './pages/Activities';
import Alumni from './pages/Alumni';
import Gallery from './pages/Gallery';
import Donation from './pages/Donation';
import StudentsCorner from './pages/StudentsCorner';
import ContactUs from './pages/ContactUs';
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import Navigation from './Navigation/Navigation';
import Home from './pages/Home';

function App() {
  return (
    <div className="App">

<Router>
      <Navigation />
      <Routes>
      <Route path="/" element={<Home/>} />
        <Route path="/members" element={<Members />} />
        <Route path="/membership-registration" element={<MembershipRegistration />} />
        <Route path="/activities" element={<Activities />} />
        <Route path="/alumni" element={<Alumni />} />
        <Route path="/gallery" element={<Gallery />} />
        <Route path="/donation" element={<Donation />} />
        <Route path="/students-corner" element={<StudentsCorner />} />
        <Route path="/contact-us" element={<ContactUs />} />
        <Route path="/about-us" element={<AboutUs />} />
      </Routes>
    </Router>
    </div>
  );
}

export default App;